<template>
    <div>
      <section class="main-content" data-date="2022年09月15日" style="display: block">
          <div class="header">
              <h1>格力服务小程序用户协议</h1>
          </div>
          <div class="contact">
              <p class="ti2">由于互联网高速发展，您与格力服务小程序签署的本协议列明的条款并不能完整罗列并覆盖您与格力服务小程序的所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，格力服务小程序平台免责声明及隐私权政策、平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用格力服务小程序平台服务，视为您同意上述补充协议。</p>
          </div>
          <div class="container">
              <div class="content-box">
              <p class="ti1">一、账户注册与使用</p>
                <p class="ti2">1.1用户资格</p>
                <p class="ti2">您需要确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用格力服务小程序平台服务，同时您理解违反前述要求可能会造成您无法正常注册及使用格力服务小程序平台服务。</p>
                
                <p class="ti2">1.2账户说明</p>
                <p class="ti2">【账户注册】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得格力服务小程序平台账户并成为格力服务小程序平台用户。格力服务小程序平台只允许每位用户使用一个格力服务小程序平台账户。如有证据证明或格力服务小程序根据格力服务小程序平台规则判断您存在不当注册或不当使用多个格力服务小程序平台账户的情形，格力服务小程序平台可采取冻结或关闭账户、取消服务工单、拒绝提供服务等措施，如给格力服务小程序平台及相关方造成损失的，您还应承担赔偿责任。</p>
                <p class="ti2">【账户使用】您有权使用您设置或确认的格力服务小程序会员昵称、邮箱、手机号码(以下简称“账户名称”)及您设置的密码(账户名称及密码合称“账户”)登录格力服务小程序平台。由于您的格力服务小程序平台账户关联您的个人信息及格力服务小程序平台商业信息，您的格力服务小程序平台账户仅限您本人使用。未经格力服务小程序平台同意，您直接或间接授权第三方平台使用您格力服务小程序平台账户或获取您账户项下信息的行为无效。如格力服务小程序根据格力服务小程序平台规则中约定的违约认定程序及标准判断您格力服务小程序平台账户的使用可能危及您的账户安全及/或格力服务小程序平台信息安全的，格力服务小程序平台可拒绝提供相应服务或终止本协议</p>

                <p class="ti2">1.3注册信息管理</p>
                    <p class="ti2">1.3.1真实合法</p>
                        <p class="ti2">【注册信息真实】在使用格力服务小程序平台服务时，您应当按格力服务小程序平台页面的提示准确完整地提供您的信息(包括您的姓名及电子邮件地址、联系电话、联系地址等)，以便格力服务小程序或格力服务小程序其他关联方与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。</p>
                        <p class="ti2">【用户名的合法性】您设置的格力服务小程序账户名称不得违反国家法律法规及格力服务小程序平台相关规则关于会员名的管理规定，否则格力服务小程序可回收您的格力服务小程序会员名。格力服务小程序会员名的回收不影响您以邮箱、手机号码登录格力服务小程序平台并使用格力服务小程序平台服务。</p>
                    <p class="ti2">1.3.2更新维护</p>
                        <p class="ti2">您应当及时更新您提供的信息，在法律有明确规定要求格力服务小程序作为平台服务提供者必须对部分用户(如平台卖家等)的信息进行核实的情况下，格力服务小程序将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。如格力服务小程序按您最后一提次供的信息与您联系未果、您未按格力服务小程序的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及格力服务小程序造成的全部损失与不利后果。格力服务小程序可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部格力服务小程序平台服务，格力服务小程序对此不承担责任。</p>
                
                <p class="ti2">1.4 账户安全规范</p>
                    <p class="ti2">【账户安全保管义务】您的账户为您自行设置并由您保管，格力服务小程序任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开格力服务小程序平台。账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，格力服务小程序并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</p>
                    <p class="ti2">【账户行为责任自负】除格力服务小程序存在过错外，您应对您账户项下的所有行为结果(包括但不限于在线签署各类协议、提交服务请求及披露信息等负责。</p>
                    <p class="ti2">【日常维护须知】如发现任何未经授权使用您账户登录格力服务小程序平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知格力服务小程序在线客服，平台将尽快为您处理相关问题。您理解格力服务小程序对您的任何请求采取行动均需要合理时间，且格力服务小程序应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除格力服务小程序存在法定过错外，格力服务小程序不承担责任。</p>
              
              <br/>
  
              <p class="ti1">二、服务条款的确认及接受</p>
                <p class="ti2">1、格力服务小程序以下称“本小程序”各项电子服务的所有权和运作权归属于“格力服务小程序”所有，本小程序提供的服务将完全按照其发布的服务条款和操作规则严格执行。您确认所有服务条款并完成注册程序时，本协议在您与本小程序间成立并发生法律效力，同时您成为本小程序正式用户。</p>
                <p class="ti2">2、根据国家法律法规变化及本小程序运营需要，格力服务小程序有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本小程序上即生效，并取代此前相关内容，您应不时关注本小程序公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本小程序；如您继续使用本小程序，即视为知悉变动内容并同意接受。</p>
                <p class="ti2">3、本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</p>
              <br/>
  
              <p class="ti1">三、服务须知</p>
                <p class="ti2">1、本小程序运用自身开发的操作系统通过国内互联网络为用户提供售后服务。使用本小程序，您必须：</p>
                    <p class="ti2">(1)自行配备上网的所需设备，包括个人手机、平板电脑、调制解调器、路由器等；</p>
                    <p class="ti2">(2)自行负担个人上网所支付的与此服务有关的电话费用、网络费用等；</p>
                    <p class="ti2">(3)选择与所安装终端设备相匹配的软件版本，包括但不限于Android、Windows、iOS等多个格力服务小程序发布的应用版本。</p>
              
              <br/>
  
              <p class="ti1">四、产品售后服务</p>
                <p class="ti2">当您使用本小程序的产品安装、维修等服务时，为确保我们服务人员能精准为您提供上门服务，我们会收集您的姓名、联系电话、服务地址、需维修产品图片（选填）等相关信息。您了解，位置信息属于您的敏感个人信息，但是上述信息对本小程序提供这类服务而言属于必要信息。</p>
              
              <br/>
  
              <p class="ti1">五、用户个人信息保护及授权</p>
                <p class="ti2">1、您知悉并同意，为方便您使用本小程序相关服务，本小程序将存储您在使用时的必要信息，包括但不限于您的真实姓名、地址、联系方式、相册、定位信息等。除法律法规规定的情形外，未经您的许可格力服务小程序不会向第三方公开、透露您的个人信息。格力服务小程序对相关信息采取专业加密存储与传输方式，利用合理措施保障用户个人信息的安全。</p>
                <p class="ti2">2、您知悉并确认，您在注册帐号或使用本小程序的过程中，需要提供真实的身份信息，格力服务小程序将根据国家法律法规相关要求，进行基于移动电话号码的真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本小程序或在使用过程中受到限制，同时，由此产生的不利后果，由您自行承担。/地区的境外管辖区，或者受到来自这些管辖区的访问。</p>
                <p class="ti2">3、您在使用本小程序某一特定服务时，该服务可能会另有单独的协议、相关业务规则等(以下统称为“单独协议”)，您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您已阅读并同意接受相关单独协议。</p>
                <p class="ti2">4、您充分理解并同意</p>
                <p class="ti2">(1)接收通过邮件、短信、电话等形式，向在本小程序注册的用户、收货人发送的工单信息、促销活动等内容；</p>
                <p class="ti2">(2)为配合行政监管机关、司法机关执行工作，在法律规定范围内格力服务小程序有权向上述行政、司法机关提供您在使用本小程序时所储存的相关信息，包括但不限于您的注册信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；</p>
                <p class="ti2">(3)格力服务小程序依法保障您在安装或使用过程中的知情权和选择权，在您使用本小程序服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，格力服务小程序有权开启包括但不限于收集地理位置、使用摄像头、启用录音等提供服务必要的辅助功能。</p>
                <p class="ti2">(4)格力服务小程序有权根据实际情况，在法律规定范围内自行决定单个用户在本小程序及服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。</p>
              <br/>
  
              <p class="ti1">六、用户行为规范</p>
                <p class="ti2">1、您同意严格遵守法律法规规章规定，依法遵守以下义务：</p>
                    <p class="ti2">(1)不得制作、传输或发表以下违法信息资料：反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律法规实施的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的，煽动推翻社会主义制度的；损害国家荣誉和利益的；歪曲、丑化、亵渎、否定英雄烈士事迹和精神，侵害英雄烈士的姓名、肖像、名誉、荣誉的；宣扬或煽动实施恐怖主义、极端主义及其活动的；煽动民族仇恨、民族歧视、破坏民族团结的言论；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱经济秩序和社会秩序的；散布淫秽、色情、暴力或者教唆犯罪的；侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；法律、行政法规禁止的其他内容。</p>
                    <p class="ti2">(2)防范和抵制制作、复制、发布含有下列内容的不良信息资料：标题严重夸张，发表内容与标题严重不符的；不当评述自然灾害、重大事故等灾难的；煽动人群歧视、地域歧视等的；宣扬低俗、庸俗、媚俗内容的；违反社会公德行为的；侵犯未成年人合法权益的；其他对网络生态造成不良影响的内容。</p>
                <p class="ti2">2、本协议依据国家相关法律法规规章制定，您亦同意严格遵守以下义务：</p>
                    <p class="ti2">(1)从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
                    <p class="ti2">(2)不得利用本小程序从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
                    <p class="ti2">(3)不得干扰本小程序的正常运转，不得侵入本小程序及国家计算机信息系统；</p>
                    <p class="ti2">(4)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、不文明的等信息资料；</p>
                    <p class="ti2">(5)不得教唆他人从事违法违规或本协议、平台规则所禁止的行为；</p>
                    <p class="ti2">(6)不得利用在本小程序注册的账户进行牟利性经营活动；</p>
                    <p class="ti2">(7)不得发布任何侵犯他人个人信息、著作权、商标权等知识产权或合法权利的内容；</p>
                <p class="ti2">3、您须对自己在网上的言论和行为承担法律责任，您若在本小程序上散布和传播反动、色情或其它违反国家法律的信息，本小程序的系统记录有可能作为您违反法律的证据。</p>
  
              <br/>
  
              <p class="ti1">七、本小程序使用规范</p>
                <p class="ti2">1、关于移动客户端软件的获取与更新：</p>
                    <p class="ti2">(1)您可以直接从格力服务小程序网站上获取格力服务小程序移动客户端软件，也可以从得到格力服务小程序授权的第三方获取，如果您从未经格力服务小程序授权的第三方获取软件或与格力服务小程序移动客户端软件名称相同的安装程序，格力服务小程序无法保证该软件能够正常使用，并对因此给您造成的损失不予负责；</p>
                    <p class="ti2">(2)为了改善用户体验、完善服务内容，格力服务小程序将不断努力开发新的服务，并为您不时提供软件更新，新版本发布后，旧版本的软件可能无法使用，格力服务小程序不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>
                <p class="ti2">2、除非法律允许或格力服务小程序书面许可，您使用本小程序过程中不得从事下列行为：</p>
                    <p class="ti2">(1)删除本小程序及其副本上关于著作权的信息；</p>
                    <p class="ti2">(2)对本小程序进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本小程序的源代码；</p>
                    <p class="ti2">(3)对格力服务小程序拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
                    <p class="ti2">(4)对本小程序或者本小程序运行过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及本小程序运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经格力服务小程序授权的第三方工具/服务接入本小程序和相关系统；</p>
                    <p class="ti2">(5)通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
                    <p class="ti2">(6)通过非格力服务小程序开发、授权的第三方软件、插件、外挂、系统，登录或使用本小程序及服务，或制作、发布、传播上述工具；</p>
                    <p class="ti2">(7)自行或者授权他人、第三方软件对本小程序及其组件、模块、数据进行干扰。</p>
                
              <br/>

              <p class="ti1">八、违约责任</p>
                <p class="ti2">1、如果格力服务小程序发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，格力服务小程序有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销等处罚，并公告处理结果。</p>
                <p class="ti2">2、格力服务小程序有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</p>
                <p class="ti2">3、您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；格力服务小程序因此遭受损失的，您也应当一并赔偿。</p>
                <p class="ti2">4、除非另有明确的书面说明，格力服务小程序不对本小程序的运营及其包含在本小程序上的信息、内容、材料、产品(包括软件)或服务作任何形式的、明示或默示的声明或担保(根据中华人民共和国法律另有规定的以外)。</p>
  
              <br/>

              <p class="ti1">九、所有权及知识产权</p>
                <p class="ti2">1、您一旦接受本协议，对于您提供、上传、创作、发布在本小程序的文字、评论、图片、照片、视频、音频等任何形式的信息内容(包括但不限于客户评价、客户咨询、各类话题文章等)，您免费授予格力服务小程序及其关联公司至保护期终止为止、不可撤销的、全球范围的、排他的许可使用著作权(包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可许可使用的权利)、肖像权、用户ID名称等相关的全部合法权利权益，就格力服务小程序具有诉讼主体资格的权利、权益，格力服务小程序有权以自身名义对第三方侵权行为取证及提起诉讼。您同意格力服务小程序及其关联公司有权存储、使用、复制、修订、编辑、发布、展示、翻译、分发、推广、出版、发行、信息网络传播您以上信息内容，有权改编制作派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。</p>
                <p class="ti2">2、格力服务小程序有权再许可给其他第三方第九条第一款的所有权利。</p>
                <p class="ti2">3、您应确保在格力服务小程序网站上发表的第九条第一款各类信息内容均不涉及侵犯第三方肖像、隐私、知识产权或其他合法权益。否则格力服务小程序有权随时采取包括但不限于删除、断开链接等措施。</p>
                <p class="ti2">4、本协议已经构成《中华人民共和国著作权法》第二十四条(条文序号依照2010年修订版《著作权法》确定)及相关法律规定的著作财产权等权利许可使用的书面协议，其效力及于您在本小程序上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
                <p class="ti2">5、您同意并已充分了解本协议的条款，承诺不将已发表于本小程序的信息，以任何形式发布或授权其它主体以任何方式使用(包括但不限于在各类网站、媒体上使用)。</p>
                <p class="ti2">6、除法律另有强制性规定外，未经格力服务小程序明确的特别书面同意，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本小程序的信息内容，否则，格力服务小程序有权追究其法律责任。</p>
                <p class="ti2">7、本小程序所刊登的资料信息(诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件)，均是格力服务小程序或其内容提供者的财产，受中国和国际版权法的保护。本小程序上所有内容的汇编是格力服务小程序的排他财产，受中国和国际版权法的保护。</p>
                
              <br/>

              <p class="ti1">十、法律管辖适用及其他</p>
                <p class="ti2">1、本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任一方有权将争议提交至格力电子商务有限公司所在地人民法院诉讼解决。</p>
                <p class="ti2">2、如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
                <p class="ti2">3、本协议未明示授权的其他权利仍由格力服务小程序保留，您在行使这些权利时须另外取得格力服务小程序的书面许可。格力服务小程序如果未行使前述任何权利，并不构成对该权利的放弃。</p>
                
              <br/>

                <p class="ti1">注：本用户注册协议版本更新日期为2022年9月15日，将于2022年9月15日正式生效。</p>
            </div>
          </div>
      </section>
    </div>
  </template>
  
  <script>
  
  export default {
      name:'selfServiceUserAgreement',
      mounted(){
        document.title = "格力服务小程序";
      },
  }
  </script>
  
  <style rel="stylesheet/scss" lang="scss" scoped>
  .main-content{
      padding: 20px 100px 100px;
      background: white;
      font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif;
  }
  @media screen and (max-width: 750px){
      .main-content{
          padding: 30px;
          background: white;
          font-family: "Helvetica Neue", Helvetica, STHeiTi, sans-serif;
      }
      h1{
          font-size: 1.5rem;
      }
  }
  .header {
      padding-top: 0.5rem;
      text-align: center;
  }
  .contact{
      padding-bottom: 20px;
  }
  .ti1 {
      margin: 10px 0;
      font-size: 13px;
      letter-spacing: 0.05rem;
      font-weight: bold;
  }
  .ti2 {
      margin: 10px 0;
      font-size: 13px;
      line-height: 28px;
      letter-spacing: 0.05rem;
      text-indent: 2em;
  }
  </style>


// WEBPACK FOOTER //
// src/views/userAgreement/selfServiceUserAgreement.vue